/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import { useGLTF,useTexture, Text3D, Center } from '@react-three/drei'

export default function Calendar(props) {
  const { nodes, materials } = useGLTF('./models/calendar_v02.gltf')
  const colors = props.colors
  const [gradientMap] = useTexture([
    'img/matcap.jpg'
  ])
  const deg= Math.PI*2/360
  return (
    <group {...props} dispose={null}>
    <group position={[0, 0.095, -0.001]} rotation={[Math.PI / 9, 0, 0]}>
      <mesh

        geometry={nodes.Back_Card.geometry}
        material={nodes.Back_Card.material}
        position={[0, -0.05, 0]}
        >
         <meshBasicMaterial color={props.isDark?colors.night2:colors.day2} />
        </mesh>
    </group>
    <group position={[0, 0.095, 0]} rotation={[-Math.PI / 9, 0, 0]}>
      <mesh

        geometry={nodes.Front_Card.geometry}
        material={nodes.Front_Card.material}
        position={[0, -0.05, 0]}
        >
      
        <meshBasicMaterial color={props.isDark?colors.night:colors.day}/>
        
        </mesh>
    </group>

    <group position={[0, 0.095, 0.0]} rotation={[-Math.PI / 9, 0, 0]}>
        <group   position={[-0.0515, -0.042, 0.0025]} rotation={[0, 0, 0]}>
       
                <Text3D
                    font="Ellograph CF_Regular.json"
                    size={ 0.025 }
                    height={0 }
                    curveSegments={ 24 }
                    >
                    {props.date[0].toString()}

                    <meshBasicMaterial color={colors.white}/>
                </Text3D>
         
        </group>
        <group   position={[-0.0535, -0.09, 0.0025]} rotation={[0, 0, 0]}>
        
                <Text3D
                    font="Ellograph CF_Regular.json"
                    size={ 0.04 }
                    height={0 }
                    curveSegments={ 12 }
                    >
                    {props.date[1].toString()}
                <meshBasicMaterial color={colors.white}/>
                </Text3D>
      
      
     
        </group>
        <group   position={[0.05, -0.089, 0.0025]} rotation={[0, 0, 90*deg]}>
        <Center top right>
         <Text3D
             font="Ellograph CF_Regular.json"
             size={ 0.029}
             height={0 }
             curveSegments={ 12 }
         
             midle
             >
                 {props.date[2].toString()} 
         <meshBasicMaterial color={colors.white}/>
         </Text3D>
         </Center>

 </group>
    </group>

    <mesh
      geometry={nodes.ringLeft.geometry}
      material={nodes.ringLeft.material}
      position={[-0.045, 0.095, 0]}
      >
      <meshMatcapMaterial matcap={gradientMap} color={props.isDark?colors.night:colors.day}/>
      
      </mesh>
      
      <mesh
      geometry={nodes.ringLeft.geometry}
      material={nodes.ringLeft.material}
      position={[0.045, 0.095, 0]}
      >
      <meshMatcapMaterial matcap={gradientMap} color={props.isDark?colors.night:colors.day}/>
      </mesh>
    <mesh

      geometry={nodes.Shadow.geometry}
      material={nodes.Shadow.material}
      position={[0, -0.00051, 0]}
      >
      <meshBasicMaterial color={props.isDark?colors.shadowNight:colors.shadowDay}/>
      </mesh>
  </group>

  
     
         
  )
}

useGLTF.preload('./models/calendar_v02.gltf')


{/* <Text3D
            font="helvetiker_regular.typeface.json"
              size={ 0.02 }
              height={0 }
              curveSegments={ 6 }
            >
             {props.date[0].toString()}
             </Text3D>
            <meshBasicMaterial color={colors.white}/> */}